<template>
  <div class="schedulingplanapproval">
    <el-row>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="(item, index) in tabsList" :label="item.name" :name="item.nursingGroupId" :key="index">
          <span slot="label">{{ item.name }}<el-badge :is-dot="Boolean(item.nums)" /></span>
          <el-row class="row-title">
            <el-col :span="2" align="right" style="margin-right: 5px"><kt-button label="上一周" type="primary"
                @click="handlePrevWeek" /></el-col>
            <el-col :span="4">
              <el-date-picker style="width: 180px" :editable="false" :clearable="false" v-model="dateValue" type="date"
                @change="changeData" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                :placeholder="thisWeekArrangePlan.optionDate">
              </el-date-picker>
            </el-col>
            <el-col :span="2"><kt-button label="下一周" type="primary" @click="handleNextWeek" /></el-col>
          </el-row>
          <el-row style="
              height: 54px;
              line-height: 54px;
              background: #f9f7fa;
              border: 1px #f1eff2 solid;
              margin-top: 20px;
            ">
            <el-col :span="4" style="font-size: 18px">
              <img src="@/assets/beadhouse/juxing.png" alt="" style="vertical-align: middle; margin: 0 10px" />
              <span>{{ thisWeekArrangePlan.schedulingPlan }}</span>
            </el-col>
            <el-col :span="6" :offset="14" align="right"><span style="margin-right: 15px">{{ week }}</span><span
                style="margin-right: 15px">{{ whichWeekTo }}</span></el-col>
          </el-row>
          <el-row>
            <el-table style="width: 100%" :data="thisWeekArrangePlanList" :header-cell-style="{
              'text-align': 'center',
              'font-size': '16px',
              'font-weight': '600',
              color: '#2d2d2d',
              'background-color': '#d4f5fa',
            }" :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :row-style="tableRowStyle">
              <el-table-column label="" align="center" min-height="100" min-width="120" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <div>{{ scope.row.name }}</div>
                  <div style="margin-left: 10px">{{ scope.row.time }}</div>
                </template>
              </el-table-column>
              <el-table-column v-for="(temp, index) in labelList" :key="index" :label="temp" align="center"
                min-height="100" min-width="100" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <div class="minHeight" v-if="index == 0">
                    <div class="ml10" v-for="(item, index) in scope.row.monUserNameArray" :key="index">
                      {{ item }}
                    </div>
                  </div>
                  <div class="minHeight" v-else-if="index == 1">
                    <div class="ml10" v-for="(item, index) in scope.row.tueUserNameArray" :key="index">
                      {{ item }}
                    </div>
                  </div>
                  <div class="minHeight" v-else-if="index == 2">
                    <div class="ml10" v-for="(item, index) in scope.row.wedUserNameArray" :key="index">
                      {{ item }}
                    </div>
                  </div>
                  <div class="minHeight" v-else-if="index == 3">
                    <div class="ml10" v-for="(item, index) in scope.row.thuUserNameArray" :key="index">
                      {{ item }}
                    </div>
                  </div>
                  <div class="minHeight" v-else-if="index == 4">
                    <div class="ml10" v-for="(item, index) in scope.row.friUserNameArray" :key="index">
                      {{ item }}
                    </div>
                  </div>
                  <div class="minHeight" v-else-if="index == 5">
                    <div class="ml10" v-for="(item, index) in scope.row.satUserNameArray" :key="index">
                      {{ item }}
                    </div>
                  </div>
                  <div class="minHeight" v-else-if="index == 6">
                    <div class="ml10" v-for="(item, index) in scope.row.sunUserNameArray" :key="index">
                      {{ item }}
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="status clearfix">
              <div class="status-operation">
                {{ thisWeekArrangePlan.operation }}
              </div>
              <div :class="{ statusImgShowA: isTrueA, statusImgShowB: isTrueB }">
                <img src="@/assets/beadhouse/pbbutongguo.png" alt="" class="status-img-x" @click="handlePass" />
                <img src="@/assets/beadhouse/pbtongguo.png" alt="" class="status-img-x" @click="handleNoPass" />
              </div>
              <div class="status-statustext">
                {{ thisWeekArrangePlan.status }}
              </div>
              <div class="status-status">{{ status }}</div>
            </div>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <!-- 审批不通过的dialog模态框-->
    <el-dialog :title="thisWeekArrangePlan.confirmationInformation" width="30%" :visible.sync="dialogVisibleNoPass"
      :close-on-click-modal="false" @close="closeDialogVisibleNoPass">
      <el-form :model="noPassForm" label-width="100px" :rules="noPassFormRules" ref="noPassForm" label-position="right">
        <el-form-item label="" prop="nursingItem">
          <span class="noPassTitle">{{ thisWeekArrangePlan.noPassTitle }}</span>
        </el-form-item>
        <el-form-item :label="thisWeekArrangePlan.reason" prop="reason">
          <el-input v-model.trim="noPassForm.reason" type="textarea" :rows="5" auto-complete="off"
            style="width: 80%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisibleNoPass = false">取消</el-button>
        <el-button :size="size" type="primary" @click.native="submitFormNoPass"
          :loading="noPassFormLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
import util from "@/utils/util.js";
export default {
  name: "SchedulingPlanApproval",
  components: { KtTable, KtButton },
  data() {
    return {
      weeklyDays: [],
      nursingGroupId: "", //护工组id
      thisWeekArrangePlan: {
        which: "第",
        week: "周",
        to: "至",
        Monday: "周一",
        Tuesday: "周二",
        Wednesday: "周三",
        Thursday: "周四",
        Friday: "周五",
        Saturday: "周六",
        Sunday: "周日",
        editorThisWeekSchedule: "编辑本周排班",
        addNextWeekSchedule: "添加下周排班",
        viewAllPlans: "查看全部计划",
        schedulingScheme: "排班方案",
        optionDate: "选择日期",
        thisWeekSchedule: "本周排班计划",
        nextWeekSchedule: "下周排班计划",
        thisMonSchedule: "本月排班计划",
        nextMonSchedule: "下月排班计划",
        allSchedule: "所有排班计划",
        loading: "拼命加载中...",
        status: "状态",
        approvalPending: "待审批",
        add: "添加",
        careManagement: "护工列表",
        schedulingPlan: "排班计划",
        operation: "操作",
        confirmationInformation: "信息确认",
        noPassTitle: "你确定不通过排班计划吗?",
        reason: "原因",
        notEmpty: "不能为空",
        messageLen: "长度在 1到 50 的字符"
      }, //引入 lang 里面的字符串资源,
      dateValue: util.formatDate.format(new Date(), "yyyy-MM-dd"),
      activeName: "",
      labelList: [],
      week: "", //第几周
      whichWeekTo: "", //某某年月日到某某年月日
      Monday: "",
      Tuesday: "",
      Wednesday: "",
      Thursday: "",
      Friday: "",
      Saturday: "",
      Sunday: "",
      tabsList: [],
      thisWeekArrangePlanList: [],
      statusImgShow: true, //审批通过和不通过图标的显示和隐藏
      status: "", //审批状态
      reason: "", //原因
      isTrueA: true,
      isTrueB: false,
      //审批不通过的dialog配置
      dialogVisibleNoPass: false, //dialog显示 true 或   隐藏 false
      noPassForm: {}, //审批不通过的数据源
      noPassFormRules: {
        reason: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur",
          },
          {
            min: 0,
            max: 50,
            message: "长度在 1到 50 的字符",
          },
        ],
      },
      noPassFormLoading: false, //审批不通过提交按钮的loading
      size: "medium", //按钮的尺寸
      roleCodeFlag: true, //by guo 2019-12-05-11:11添加  判断是否为护工的角色  为护工就为false  否则就为true
    };
  },
  methods: {
    /* 不通过审批清空数据 */
    closeDialogVisibleNoPass() {
      this.$refs["noPassForm"].resetFields();
    },
    /* 
            选项卡点击事件
        */
    handleClick(tab, event) {
      console.log(tab, event);
      console.log(tab.name);
      this.nursingGroupId = tab.name;
      this.queryScheduleList();
    },

    /* 
            上一周
        */
    handlePrevWeek() {
      // 获得当前日期
      var doday = new Date(this.dateValue);
      console.log(doday);
      doday = Date.parse(doday);
      console.log(doday);
      // 将当前日期减去7天的时间
      doday = doday - 1000 * 60 * 60 * 24 * 7;
      // timeFormat()日期格式化
      var nowDate = util.formatDate.format(new Date(doday));
      console.log(nowDate);
      // 获得value
      this.dateValue = nowDate;
      console.log(this.dateValue);
      this.labelList = []; //清空数据
      this.week = this.getWeekNumber(this.dateValue);
      this.getWeekUI(this.dateValue);
      this.queryScheduleList();
    },

    /* 
            下一周
        */
    handleNextWeek() {
      // 获得当前日期
      var doday = new Date(this.dateValue);
      console.log(doday);
      doday = Date.parse(doday);
      console.log(doday);
      // 将当前日期加上7天的时间
      doday = doday + 1000 * 60 * 60 * 24 * 7;
      // timeFormat()日期格式化
      var nowDate = util.formatDate.format(new Date(doday));
      console.log(nowDate);
      // 获得value
      this.dateValue = nowDate;
      console.log(this.dateValue);
      this.labelList = []; //清空数据
      this.week = this.getWeekNumber(this.dateValue);
      this.getWeekUI(this.dateValue);
      this.queryScheduleList();
    },

    /* 
            点击时间获取数据  by xiang
        */
    changeData(val) {
      this.labelList = []; //清空数据
      console.log(val);
      this.week = this.getWeekNumber(val);
      this.getWeekUI(val);
      this.queryScheduleList();
    },

    /* ************* 排班计划的时间处理 ********** */

    /* 
            获取某年某月某天是第几周   第一天为周一
        */
    getWeekNumber(data) {
      var today = new Date(data);
      var firstDay = new Date(today.getFullYear(), 0, 1);
      var dayOfWeek = firstDay.getDay();
      var spendDay = 1;
      if (dayOfWeek != 0) {
        spendDay = 7 - dayOfWeek + 1;
      }
      firstDay = new Date(today.getFullYear(), 0, 1 + spendDay);
      var d = Math.ceil((today.valueOf() - firstDay.valueOf()) / 86400000);
      var result = Math.ceil(d / 7);
      console.log(result, "周几周几周几周几周几周几");
      return result + 1;
    },

    /*  
            获取本周 周一是1,周日是7
        */
    getWeekDay(val) {
      var new_Date = new Date(val);
      var timesStamp = new_Date.getTime();
      var currenDay = new_Date.getDay();
      var dates = [];
      for (var i = 0; i < 7; i++) {
        dates.push(
          new Date(
            timesStamp + 24 * 60 * 60 * 1000 * (i - ((currenDay + 6) % 7))
          )
            .toLocaleDateString()
            .replace(/[年月]/g, "-")
            .replace(/[日上下午]/g, "")
        );
      }
      console.log(dates);
      this.weeklyDays = dates;
    },

    /* 
            获取第几周  获取下周的星期和日期 
        */
    getWeekUI(data) {
      this.getWeekDay(data);
      console.log(this.weeklyDays);
      let weekday = this.getWeekNumber(data);
      this.week =
        this.thisWeekArrangePlan.which +
        weekday +
        this.thisWeekArrangePlan.week;
      this.whichWeekTo =
        this.weeklyDays[0] +
        this.thisWeekArrangePlan.to +
        this.weeklyDays[6];
      this.Monday =
        this.thisWeekArrangePlan.Monday + this.weeklyDays[0];
      this.Tuesday =
        this.thisWeekArrangePlan.Tuesday + this.weeklyDays[1];
      this.Wednesday =
        this.thisWeekArrangePlan.Wednesday + this.weeklyDays[2];
      this.Thursday =
        this.thisWeekArrangePlan.Thursday + this.weeklyDays[3];
      this.Friday =
        this.thisWeekArrangePlan.Friday + this.weeklyDays[4];
      this.Saturday =
        this.thisWeekArrangePlan.Saturday + this.weeklyDays[5];
      this.Sunday =
        this.thisWeekArrangePlan.Sunday + this.weeklyDays[6];
      this.labelList.push(
        this.Monday,
        this.Tuesday,
        this.Wednesday,
        this.Thursday,
        this.Friday,
        this.Saturday,
        this.Sunday
      );
    },

    /* 
            全部计划时间日期 数据回显
        */
    getWeekAndDateHtml() {
      let today = new Date();
      let nowDate = this.timeFormat(new Date().getTime());
      today.setTime(today.getTime());
      this.getWeekUI(nowDate);
    },

    /* 
            获取所有的护工组
        */
    selectShowAll() {
      //请求数据之前先把数据清空
      this.tabsList = [];
      this.$postJson("omc/group/selectShowAll").then((res) => {
        console.log(res);
        if (res.result.length > 0) {
          res.result.forEach((item, index) => {
            if (index == 0) {
              //获取默认初始值
              this.activeName = String(item.id);
              this.nursingGroupId = String(item.id);
            }
            var tabsObj = {};
            tabsObj.nursingGroupId = String(item.id);
            tabsObj.name = item.name;
            tabsObj.nums = item.nums;
            this.tabsList.push(tabsObj);
          });
        }
        console.log(this.tabsList);
      });
    },

    /* 
            查询排班计划
        */
    queryScheduleList() {
      let params = {};
      console.log(this.week, "----^^^$$$$$$$");

      //跨年week值修改 by xiang 2019-12-26
      let weekDay = this.week.replace(/[^0-9]/gi, "");
      let weekFirst = parseInt(this.weeklyDays[6]);
      console.log(weekFirst, "dsdssdssdsd");
      if (weekDay > 52) {
        weekDay = "1";
        weekFirst = parseInt(weekFirst);
      }
      params.week = (weekFirst + weekDay) * 1;
      params.nursingGroupId = this.nursingGroupId;
      console.log(params);
      this.thisWeekArrangePlanList = []; //请求之前先把数据清空
      this.$postJson("omc/schedule/queryScheduleList", params).then((res) => {
        console.log(res);
        console.log(this.thisWeekArrangePlanList);
        if (res.result != null && res.result.length > 0) {
          res.result.forEach((temp) => {
            let item = {};
            item.id = temp.id; //排班Id  修改的时候提交数据需要
            item.week = temp.week; //排班的周
            item.monDate = temp.monDate;
            item.monUserId = temp.monUserId;
            item.monRealName = temp.monRealName;
            item.monUserNameArray = temp.monUserNameArray;
            item.tueDate = temp.tueDate;
            item.tueUserId = temp.tueUserId;
            item.tueRealName = temp.tueRealName;
            item.tueUserNameArray = temp.tueUserNameArray;
            item.wedDate = temp.wedDate;
            item.wedUserId = temp.wedUserId;
            item.wedRealName = temp.wedRealName;
            item.wedUserNameArray = temp.wedUserNameArray;
            item.thuDate = temp.thuDate;
            item.thuUserId = temp.thuUserId;
            item.thuRealName = temp.thuRealName;
            item.thuUserNameArray = temp.thuUserNameArray;
            item.friDate = temp.friDate;
            item.friUserId = temp.friUserId;
            item.friRealName = temp.friRealName;
            item.friUserNameArray = temp.friUserNameArray;
            item.satDate = temp.satDate;
            item.satUserId = temp.satUserId;
            item.satRealName = temp.satRealName;
            item.satUserNameArray = temp.satUserNameArray;
            item.sunDate = temp.sunDate;
            item.sunUserId = temp.sunUserId;
            item.sunRealName = temp.sunRealName;
            item.sunUserNameArray = temp.sunUserNameArray;
            item.name = temp.omcShifts.name;
            item.shiftsId = temp.omcShifts.id;
            item.planId = temp.omcShifts.planid;
            item.time = temp.omcShifts.time;
            this.thisWeekArrangePlanList.push(item);

            //by guo 2019-12-17-19-20添加   需要判断排班方案是否相同   相同并且存在排班计划才获取status的值 否则就为""
            var reason =
              temp.reason != null &&
                temp.reason != undefined &&
                temp.reason != ""
                ? temp.reason
                : "";
            switch (temp.status) {
              case 0:
                this.status = "未审批";
                this.isTrueA = true;
                this.isTrueB = false;
                break;
              case 1:
                this.status = " 审批不通过" + "         原因：" + reason;
                this.isTrueA = false;
                this.isTrueB = true;
                break;
              default:
                this.status = "审批通过";
                this.isTrueA = false;
                this.isTrueB = true;
            }
          });
        } else {
          this.status = ""; //没有排班计划置空数据
          this.isTrueA = false;
          this.isTrueB = true;
        }
        console.log(this.thisWeekArrangePlanList, "************^^^^****");
      });
    },

    /* 
            排班审批通过confirm
        */
    handlePass() {
      this.$confirm("你确定通过排班计划吗?", "信息确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          let params = {};
          params.nursingGroupId = this.nursingGroupId;
          params.status = 2; //0-未审批1-审批未通过2-审批通过
          (params.reason = this.noPassForm.reason), //审批原因
            (params.omcSchedulList = this.getOmcSchedulList()); //获取omcSchedulList数组
          console.log(params);
          this.noPassFormLoading = true;
          this.$postJson("omc/schedule/approvalSchedule", params).then(
            (res) => {
              console.log(res);
              this.dialogVisibleNoPass = false;
              this.noPassFormLoading = false;
              if (res.code == 200) {
                this.$message({ message: res.message, type: "success" });
              } else {
                this.$message({ message: res.message, type: "error" });
              }
              this.selectShowAll();
              this.queryScheduleList();
            }
          );
        })
        .catch(() => { });
    },

    /* 
            排班审批不通过弹出dialog
        */
    handleNoPass() {
      this.dialogVisibleNoPass = true;
      this.noPassForm = {
        reason: "",
      };
    },

    /* 
            审批不通过提交数据
        */
    submitFormNoPass() {
      this.$refs.noPassForm.validate((valid) => {
        if (valid) {
          let params = {};
          params.nursingGroupId = this.nursingGroupId;
          params.status = 1; //0-未审批1-审批未通过2-审批通过
          (params.reason = this.noPassForm.reason), //审批原因
            (params.omcSchedulList = this.getOmcSchedulList()); //获取omcSchedulList数组
          console.log(params);
          this.noPassFormLoading = true;
          this.$postJson("omc/schedule/approvalSchedule", params).then(
            (res) => {
              console.log(res);
              this.dialogVisibleNoPass = false;
              this.noPassFormLoading = false;
              if (res.code == 200) {
                this.$message({ message: res.message, type: "success" });
              } else {
                this.$message({ message: res.message, type: "error" });
              }
              this.queryScheduleList();
            }
          );
        }
      });
    },

    /* 
            获取需要提交的omcSchedulList数组
        */
    getOmcSchedulList() {
      let omcSchedulList = [];
      //循环遍历数组 将值赋给thisWeekArrangePlanObj这个对象  再push进omcSchedulList数组
      this.thisWeekArrangePlanList.forEach((item) => {
        console.log(item);
        let thisWeekArrangePlanObj = {};
        thisWeekArrangePlanObj.shiftsId = item.shiftsId;
        thisWeekArrangePlanObj.planId = item.planId;
        thisWeekArrangePlanObj.week = item.week;
        thisWeekArrangePlanObj.monDate = item.monDate;
        thisWeekArrangePlanObj.monUserId = item.monUserId;
        thisWeekArrangePlanObj.monRealName = item.monRealName;
        thisWeekArrangePlanObj.tueDate = item.tueDate;
        thisWeekArrangePlanObj.tueUserId = item.tueUserId;
        thisWeekArrangePlanObj.tueRealName = item.tueRealName;
        thisWeekArrangePlanObj.wedDate = item.wedDate;
        thisWeekArrangePlanObj.wedUserId = item.wedUserId;
        thisWeekArrangePlanObj.wedRealName = item.wedRealName;
        thisWeekArrangePlanObj.thuDate = item.thuDate;
        thisWeekArrangePlanObj.thuUserId = item.thuUserId;
        thisWeekArrangePlanObj.thuRealName = item.thuRealName;
        thisWeekArrangePlanObj.friDate = item.friDate;
        thisWeekArrangePlanObj.friUserId = item.friUserId;
        thisWeekArrangePlanObj.friRealName = item.friRealName;
        thisWeekArrangePlanObj.satDate = item.satDate;
        thisWeekArrangePlanObj.satUserId = item.satUserId;
        thisWeekArrangePlanObj.satRealName = item.satRealName;
        thisWeekArrangePlanObj.sunDate = item.sunDate;
        thisWeekArrangePlanObj.sunUserId = item.sunUserId;
        thisWeekArrangePlanObj.sunRealName = item.sunRealName;
        thisWeekArrangePlanObj.id = item.id;
        omcSchedulList.push(thisWeekArrangePlanObj);
      });
      return omcSchedulList;
    },

    /* 
            转换时间格式
        */
    timeFormat(timestamp) {
      //timestamp是整数，否则要parseInt转换,不会出现少个0的情况
      var time = new Date(timestamp);
      var year = time.getFullYear();
      var month = time.getMonth() + 1;
      var date = time.getDate();
      var hours = time.getHours();
      var minutes = time.getMinutes();
      var seconds = time.getSeconds();
      return year + "-" + this.add0(month) + "-" + this.add0(date);
    },

    /* 
            逢10补0
        */
    add0(m) {
      return m < 10 ? "0" + m : m;
    },

    /* 
            修改table tr行的背景色
        */
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
  },
  created() {
    //by guo 2019-12-05-11:15 添加
    let roleCode = sessionStorage.getItem("roleCode");
    if (roleCode == "nursing") {
      this.roleCodeFlag = false;
    }
  },
  mounted() {
    if (this.roleCodeFlag == true) {
      //by guo 2019-12-05-11:15 添加
      this.getWeekAndDateHtml();
      this.selectShowAll();
      //延迟加载，否则this.nursingGroupId无法取到
      this.$nextTick(() => {
        setTimeout(() => {
          this.queryScheduleList();
        }, 500);
      });
      //by guo 2019-11-14-19:15添加  监听刷新表格的数据
      //监听 待办事项页面的
      this.$bus.$on("refreshSchedulingApproval", () => {
        console.log("待办事项页面传来的");
        this.queryScheduleList(); //刷新列表的数据
      });
    } else {
      //by guo 2019-12-05-11:15 添加
      this.$message({
        message: "该角色为护工,不能进行排班审批",
        type: "error",
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.schedulingplanapproval {
  width: 100%;
  height: 100%;
  background: #fefefe;

  .ml10 {
    margin-left: 10px;
    padding-top: 5px;
  }

  //by guo 2019-10-30-17:17 修改  给每一行每一列的给一个最小高度  让其可以高度自适应
  .minHeight {
    min-height: 40px;
    line-height: 20px;
  }

  .status {
    width: 100%;
    height: 65px;
    border: 1px solid #ebeef5;
    border-top: none;
    box-sizing: border-box;

    .status-operation {
      width: 204px;
      height: 65px;
      line-height: 65px;
      text-align: center;
      border-right: 1px solid #ebeef5;
      float: left;
    }

    .statusImgShowA {
      width: 492px;
      height: 65px;
      line-height: 65px;
      text-align: center;
      border-right: 1px solid #ebeef5;
      float: left;
      opacity: 1;

      .status-img-x {
        vertical-align: middle;
        margin: 0 20px;
        cursor: pointer;
      }
    }

    .statusImgShowB {
      width: 492px;
      height: 65px;
      line-height: 65px;
      text-align: center;
      border-right: 1px solid #ebeef5;
      float: left;
      opacity: 0;
    }

    .status-statustext {
      width: 165px;
      height: 65px;
      line-height: 65px;
      text-align: center;
      border-left: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
      float: left;
    }

    .status-status {
      min-width: 97%;
      height: 65px;
      line-height: 65px;
      text-align: center;
      float: left;
    }
  }

  .noPassTitle {
    text-align: center;
    color: #002;
    font-size: 18px;
  }
}

.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}

.clearfix {
  *zoom: 1;
}

//去除表格hover高亮
::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #ffffff !important;
}

::v-deep .el-table .el-table__body td {
  padding: 0px !important;
}

::v-deep .el-table .cell {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

// ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}

::v-deep .el-dialog .el-dialog__body {
  padding: 20px 20px 10px 20px !important;
}
</style>
